import React from 'react';
import cx from 'classnames';
import { Divider } from 'antd';
import { Button } from 'semantic-ui-react';

import '../AddEditClinic/index.scss';

import ActionRequired from './ActionRequired';
import ClaimDetails from './ClaimDetails';
import ServiceDetails from './ServiceDetails';
import CaseCancellation from './CaseCancellation';

const STEPS = ['Action Required', 'Claim Details', 'Service Details', 'Cancellation Status'];

class AddEditImagingServices extends React.Component {
  state = {
    currentStep: 0,
  };

  handleStepChange = step => () => {
    this.setState({ currentStep: step });
  };

  renderForm = () => {
    switch (this.state.currentStep) {
      case 1:
        return <ClaimDetails />;
      case 2:
        return <ServiceDetails />;
      case 3:
        return <CaseCancellation />;
      default:
        return <ActionRequired />;
    }
  };

  render() {
    return (
      <div className="page-container">
        <div className="form-container">
          <h1 className="form-title">{STEPS[this.state.currentStep]}</h1>
          {this.renderForm()}
        </div>
        <div className="step-container step-container-sticky">
          {STEPS.map((step, idx) => (
            <Button
              key={step}
              fluid
              size="large"
              className={cx('step', { active: this.state.currentStep === idx })}
              onClick={this.handleStepChange(idx)}
            >
              {idx + 1}. {step}
            </Button>
          ))}
        </div>
        <div className="form-footer">
          <Divider />
          <Button primary>Save</Button>
          <Button className="negative">Close</Button>
        </div>
      </div>
    );
  }
}

export default AddEditImagingServices;
